import React, { useState } from 'react';
import Header from './components/Header';
import Section from './components/Section';
import ModalWrapper from 'Common/Components/ModalWrapper';
import { Wrapper, Content } from './styled';
import { getGeneralHostsTags, getGeneralServicesTags, getGeneralTags } from 'Screens/Contextualization/Tags/actions/Actions';

const TagsModal = ({
  vulnsOptions, hostsOptions, servicesOptions, assetsTagsAdded,
  vulnsTagsAdded, servicesTagsAdded, saveTags
}) => {
  const [vulnsTags, setVulnsTags] = useState(vulnsTagsAdded);
  const [hostTags, setHostTags] = useState(assetsTagsAdded);
  const [servicesTags, setServicesTags] = useState(servicesTagsAdded);

  return (
    <ModalWrapper>
        <Wrapper>
          <Header vulnsTags={ vulnsTags } hostTags={ hostTags } servicesTags={ servicesTags } saveTags={ saveTags } />
          <Content>
            <Section
              entity="host"
              tags={ hostTags }
              setTags={ setHostTags }
              label="Add Tags to Assets"
              getOptions={ getGeneralHostsTags }
              options={ hostsOptions }
            />
            <Section
              entity="vuln"
              tags={ vulnsTags }
              setTags={ setVulnsTags }
              label="Add Tags to Services"
              getOptions={ getGeneralTags }
              options={ vulnsOptions }
            />
            <Section
              entity="service"
              tags={ servicesTags }
              setTags={ setServicesTags }
              label="Add Tags to Vulnerabilities"
              getOptions={ getGeneralServicesTags }
              options={ servicesOptions }
            />
          </Content>
        </Wrapper>
    </ModalWrapper>
  );
};

export default TagsModal;
